// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Utils$OrcaPaymentPage from "./Utilities/Utils.bs.js";
import * as CardUtils$OrcaPaymentPage from "./CardUtils.bs.js";
import * as ConfirmType$OrcaPaymentPage from "./Types/ConfirmType.bs.js";
import * as PaymentBody$OrcaPaymentPage from "./Utilities/PaymentBody.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "./Utilities/RecoilAtoms.bs.js";
import * as ErrorOccured$OrcaPaymentPage from "./Components/ErrorOccured.bs.js";
import * as CardThemeType$OrcaPaymentPage from "./Types/CardThemeType.bs.js";
import * as PaymentHelpers$OrcaPaymentPage from "./Utilities/PaymentHelpers.bs.js";
import * as CommonCardProps$OrcaPaymentPage from "./Hooks/CommonCardProps.bs.js";
import * as PaymentTypeContext$OrcaPaymentPage from "./Context/PaymentTypeContext.bs.js";
import * as RenderPaymentMethods$OrcaPaymentPage from "./RenderPaymentMethods.bs.js";

function setUserError(message) {
  Utils$OrcaPaymentPage.postFailedSubmitResponse("validation_error", message);
}

function Payment(props) {
  var logger = props.logger;
  var paymentMode = props.paymentMode;
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.configAtom);
  var localeString = match.localeString;
  var match$1 = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.keys);
  var iframeId = match$1.iframeId;
  var isManualRetryEnabled = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.isManualRetryEnabled);
  var areRequiredFieldsValid = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.areRequiredFieldsValid);
  var match$2 = React.useState(function () {
        return false;
      });
  var setIsFocus = match$2[1];
  var intent = PaymentHelpers$OrcaPaymentPage.usePaymentIntent(logger, "Card");
  var paymentType = React.useMemo((function () {
          return CardThemeType$OrcaPaymentPage.getPaymentMode(paymentMode);
        }), [paymentMode]);
  var match$3 = CommonCardProps$OrcaPaymentPage.useCardForm(logger, paymentType);
  var zipProps = match$3.zipProps;
  var cvcProps = match$3.cvcProps;
  var setCvcError = cvcProps.setCvcError;
  var cvcNumber = cvcProps.cvcNumber;
  var isCVCValid = cvcProps.isCVCValid;
  var expiryProps = match$3.expiryProps;
  var setExpiryError = expiryProps.setExpiryError;
  var cardExpiry = expiryProps.cardExpiry;
  var isExpiryValid = expiryProps.isExpiryValid;
  var cardProps = match$3.cardProps;
  var cardEligibilityError = cardProps.cardEligibilityError;
  var cardBrand = cardProps.cardBrand;
  var setCardError = cardProps.setCardError;
  var cardNumber = cardProps.cardNumber;
  var isCardValid = cardProps.isCardValid;
  var handleElementFocus = React.useMemo((function () {
          return function (isFocus) {
            setIsFocus(function (param) {
                  return isFocus;
                });
          };
        }), [
        isCardValid,
        isCVCValid,
        isExpiryValid,
        zipProps.isZipValid
      ]);
  React.useEffect((function () {
          if (isCardValid !== undefined && isExpiryValid !== undefined && isCVCValid !== undefined) {
            CardUtils$OrcaPaymentPage.emitIsFormReadyForSubmission(isCardValid && isExpiryValid && isCVCValid && areRequiredFieldsValid);
          }
          
        }), [
        isCardValid,
        isExpiryValid,
        isCVCValid,
        areRequiredFieldsValid
      ]);
  React.useEffect((function () {
          var handleDoSubmit = function (ev) {
            var json = Utils$OrcaPaymentPage.safeParse(ev.data);
            var jsonDict = Utils$OrcaPaymentPage.getDictFromJson(json);
            var confirm = ConfirmType$OrcaPaymentPage.itemToObjMapper(jsonDict);
            if (confirm.doSubmit) {
              var confirmParam = confirm.confirmParams;
              var match = CardThemeType$OrcaPaymentPage.getPaymentMode(paymentMode);
              var validFormat;
              switch (match) {
                case "Card" :
                    validFormat = Core__Option.getOr(isCardValid, false) && Core__Option.getOr(isExpiryValid, false) && Core__Option.getOr(isCVCValid, false) && Core__Option.isNone(cardEligibilityError);
                    break;
                case "CardNumberElement" :
                    validFormat = Core__Option.getOr(isCardValid, false) && CardUtils$OrcaPaymentPage.checkCardCVC(CardUtils$OrcaPaymentPage.getCardElementValue(iframeId, "card-cvc"), cardBrand) && CardUtils$OrcaPaymentPage.checkCardExpiry(CardUtils$OrcaPaymentPage.getCardElementValue(iframeId, "card-expiry")) && Core__Option.isNone(cardEligibilityError);
                    break;
                default:
                  validFormat = true;
              }
              var cardNetwork = [[
                  "card_network",
                  cardBrand !== "" ? cardBrand : null
                ]];
              if (validFormat) {
                var match$1 = CardThemeType$OrcaPaymentPage.getPaymentMode(paymentMode);
                var body;
                switch (match$1) {
                  case "Card" :
                      var match$2 = CardUtils$OrcaPaymentPage.getExpiryDates(cardExpiry);
                      body = PaymentBody$OrcaPaymentPage.cardPaymentBody(cardNumber, match$2[0], match$2[1], Caml_option.some(undefined), cvcNumber, cardNetwork, undefined);
                      break;
                  case "CardNumberElement" :
                      var match$3 = CardUtils$OrcaPaymentPage.getExpiryDates(CardUtils$OrcaPaymentPage.getCardElementValue(iframeId, "card-expiry"));
                      var localCvcNumber = CardUtils$OrcaPaymentPage.getCardElementValue(iframeId, "card-cvc");
                      body = PaymentBody$OrcaPaymentPage.cardPaymentBody(cardNumber, match$3[0], match$3[1], Caml_option.some(undefined), localCvcNumber, cardNetwork, undefined);
                      break;
                  default:
                    body = [];
                }
                var match$4 = CardThemeType$OrcaPaymentPage.getPaymentMode(paymentMode);
                switch (match$4) {
                  case "Card" :
                  case "CardNumberElement" :
                      return intent(false, body, confirmParam, undefined, undefined, undefined, isManualRetryEnabled);
                  default:
                    return ;
                }
              } else {
                if (cardNumber === "") {
                  setCardError(function (param) {
                        return localeString.cardNumberEmptyText;
                      });
                  Utils$OrcaPaymentPage.postFailedSubmitResponse("validation_error", localeString.enterFieldsText);
                } else if (Core__Option.isSome(cardEligibilityError)) {
                  var msg = PaymentHelpers$OrcaPaymentPage.getCardEligibilityErrorText(cardEligibilityError, localeString);
                  setCardError(function (param) {
                        return msg;
                      });
                  Utils$OrcaPaymentPage.postFailedSubmitResponse("validation_error", msg);
                }
                if (cardExpiry === "") {
                  setExpiryError(function (param) {
                        return localeString.cardExpiryDateEmptyText;
                      });
                  Utils$OrcaPaymentPage.postFailedSubmitResponse("validation_error", localeString.enterFieldsText);
                }
                if (cvcNumber === "") {
                  setCvcError(function (param) {
                        return localeString.cvcNumberEmptyText;
                      });
                  Utils$OrcaPaymentPage.postFailedSubmitResponse("validation_error", localeString.enterFieldsText);
                }
                if (!validFormat) {
                  return Utils$OrcaPaymentPage.postFailedSubmitResponse("validation_error", localeString.enterValidDetailsText);
                } else {
                  return ;
                }
              }
            }
            
          };
          return Utils$OrcaPaymentPage.handleMessage(handleDoSubmit, "");
        }), [
        cardNumber,
        cvcNumber,
        cardExpiry,
        isCVCValid,
        isExpiryValid,
        isCardValid,
        cardEligibilityError,
        match$1.sdkAuthorization
      ]);
  if (props.integrateError) {
    return React.createElement(ErrorOccured$OrcaPaymentPage.make, {});
  } else {
    return React.createElement(PaymentTypeContext$OrcaPaymentPage.provider, {
                value: {
                  paymentType: paymentType
                },
                children: React.createElement(RenderPaymentMethods$OrcaPaymentPage.make, {
                      paymentType: paymentType,
                      cardProps: cardProps,
                      expiryProps: expiryProps,
                      cvcProps: cvcProps,
                      zipProps: zipProps,
                      handleElementFocus: handleElementFocus,
                      blurState: match$3.blurState,
                      isFocus: match$2[0]
                    })
              });
  }
}

var make = Payment;

export {
  setUserError ,
  make ,
}
/* react Not a pure module */
